module.exports = __webpack_public_path__ + "img/Surface2.5a3ae6d1.jpg";